import React from "react";
import { CreateContentListProps, CreateContentListState } from "./models";
import { Box } from "@mui/material";
import { t } from "@lingui/macro";
import { withSnackbar, WithSnackbarProps } from "notistack";
import ZPlayLoader from "commons/zplay-loader";
import { ContentProducerService } from "services/content-producer-service";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import { CreateContentListResponse, ErrorResponseApi, GetCollectionListResponse } from "models/response";
import { CreateContentListRequest } from "models/request";
import { CreateAndEditContentList } from "components/backoffice/content-list";
import { ZPlayNetworkService, ZPlayUploadLoader } from "commons";
import { S3 } from "aws-sdk";
import { VODPartConfirmData } from "models/request/multipart-confirm-upload-request";


class CreateContentList extends React.Component<CreateContentListProps & WithSnackbarProps, CreateContentListState> {

    private s3;
    private multipartUploadedPartsETagList?: VODPartConfirmData[]
    private totalParts: number;
    private partsUploaded: number;

    constructor(props: any) {
        super(props);

        //FIXME: Trovare un posto dove mettere queste credenziali grz
        this.s3 = new S3({
            credentials: {
                accessKeyId: "AKIA37UMFBYMEHP5BU4Y",
                secretAccessKey: "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"
            },
            region: "eu-central-1"
        });

        this.multipartUploadedPartsETagList = [];
        this.totalParts = 0;
        this.partsUploaded = 0;

        this.state={
            isLoading: true,
            collectionsList: null,
            currentUploadPercentage: 0,
            uploadStageMessage: "",
            thumbUploadUrl: null,
            thumbnailFile: null,
            isUploading: false
        }
    }

    componentDidMount() {
        ContentProducerService.getCollectionList(this.getCollectionListSuccessCallback, this.getCollectionListErrorCallback);
    }

    getCollectionListSuccessCallback = (data: GetCollectionListResponse) => {
        this.setState(() => ({
            collectionsList: data,
            isLoading: false
        }))
    }

    getCollectionListErrorCallback = (err: ErrorResponseApi) => {

        let emptyCollectionList: GetCollectionListResponse = {
            awardList: {list:[], size:0},
            countryList:  {list:[], size:0},
            festivalList:  {list:[], size:0},
            genreList:  {list:[], size:0},
            languageList:  {list:[], size:0},
            tagList:  {list:[], size:0},
            contentIssuesList: {list:[], size: 0},
            seriesList: {list:[], size: 0}
        };

        this.setState(() => ({
            isLoading: false,
            collectionsList: emptyCollectionList,
        }));

        this.props.enqueueSnackbar(t({
            id: "cc-error-get-collection-list-error",
            message: "Si è verificato un errore. Non è stato possibile recuperare i dati"
        }), {
            variant: "error",
        });
    }

    private checkRequest = (request: CreateContentListRequest): boolean => {
        let flag : boolean = true

        if(request.title.length === 0){
            this.props.enqueueSnackbar(t({
                id: "cc-no-title-create-content-list",
                message: "È necessario inserire almeno un titolo"
            }), {
                variant: "error",
            });
            flag = false
        }


        if((request.featuredFrom as any !== "" && request.featuredTo as any === "") || (request.featuredFrom as any === "" && request.featuredTo as any !== "")){
            this.props.enqueueSnackbar(t({
                id: "cc-no-featured-create-content-list",
                message: "È necessario che le date \"in evidenza\" siano inserite o entrambe o nessuna"
            }), {
                variant: "error",
            });
            flag = false
        }


        /*if (!request.thumbnailData){
            this.props.enqueueSnackbar(t({
                id: "cc-form-validation-no-thumbnail-file",
                message: "Non è stata caricata un'immagine di copertina"
            }), {
                variant: "error",
            });
            flag = false
        }*/

        return flag

    }

    private submitForm = (request: CreateContentListRequest) => {

        if (!this.checkRequest(request))
            return

        let thumbnailFile = request.thumbnailData;

        this.setState(() => ({
            isLoading: true,
            thumbnailFile: thumbnailFile
        }))

        if (thumbnailFile) {
            request.thumbnailData = {
                fileName: thumbnailFile.name,
                format: thumbnailFile.type.split("/")[1]
            };
            ContentProducerService.createContentList(request, this.startThumbUpload, this.createContentListErrorCallback);
        }else{
            request.thumbnailData = null
            ContentProducerService.createContentList(request, this.createContentListSuccessCallback, this.createContentListErrorCallback);
        }
    };


    private startThumbUpload = (data: CreateContentListResponse) => {

        this.multipartUploadedPartsETagList = [];
        this.totalParts = 0;
        this.partsUploaded = 0;

        this.setState(() => ({
            currentUploadPercentage: 0,
            uploadStageMessage: t({
                id: "cc-upload-thumbnail-stage",
                message: "Caricamento della thumbnail in corso..."
            }),
            uploadedContentList: data.contentList,
            isUploading: true,
            isLoading: false
        }));

        ZPlayNetworkService.xhrMultipartUpload(data.s3PresignedCoverUrl ?? "", this.state.thumbnailFile, this.progressCallback)
            .then(this.confirmThumbUpload)
            .catch(this.createContentListErrorCallback)
    };

    private confirmThumbUpload = () => {

        this.setState(() => ({
            currentUploadPercentage: 0
        }));

        if (this.state.uploadedContentList)
            ContentProducerService.confirmThumbnailUploadContentList(this.state.uploadedContentList.id, this.createContentListSuccessCallback, this.createContentListErrorCallback);
    };


    private progressCallback = (percentage: number) => {
        this.setState(() => ({ currentUploadPercentage: percentage }))
    }

    createContentListSuccessCallback = (data: any) => {
        this.setState(() => ({
            isLoading: false,
            isUploading: false
        }))

        this.props.enqueueSnackbar(t({
            id: "cc-success-create-content-list-error",
            message: "La content list è stata creata"
        }), {
            variant: "success",
        })
    }

    createContentListErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            isLoading: false,
            isUploading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "cc-error-create-content-list-error",
            message: "Si è verificato un errore. Non è stato possibile creare la content list"
        }), {
            variant: "error",
        });
    }

    render() {
        return (
            <Box sx={{ p: 5 }}>
                {this.state.isUploading &&
                <ZPlayUploadLoader progress={this.state.currentUploadPercentage}
                                   message={this.state.uploadStageMessage} />}
                {this.state.isLoading && <ZPlayLoader />}
                <NavigationBack/>
                <Box maxWidth={"1000px"} padding={"30px 10px 10px"} margin={"0 auto"}>
                    {!this.state.isLoading &&
                        <CreateAndEditContentList
                            contentList={null}
                            collectionsList={this.state.collectionsList}
                            onSubmit={this.submitForm}
                        />

                    }
                </Box>
            </Box>
        );
    }
}

export default withSnackbar(CreateContentList);